import { call, put, takeEvery } from "redux-saga/effects";
import { dsDoiTuongDuThiApi } from "../../../api/tct/dsDoiTuongDuThiApi";
import { rootActions } from "../../actions/rootActions";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eIDsDoiTuongDuThiActionIds, IDsDoiTuongDuThiActionTypes } from "../../action-types/tct/IDsDoiTuongDuThiActions";
import { IDsDoiTuongDuThiUpdateDuyetRequest } from "../../../model/request/tct/IDsDoiTuongDuThiUpdateDuyetRequest";

export function* dsDoiTuongDuThiSaga(): any {
    yield takeEvery(eIDsDoiTuongDuThiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eIDsDoiTuongDuThiActionIds.UPDATE_DUYET_START, updateDuyetWorker);
}
function* loadWorker(action: IDsDoiTuongDuThiActionTypes): any {
        const id_dot_thi = action.payload as number;
        debugger
        const res: IBaseRespone = yield call(dsDoiTuongDuThiApi.SelectByDotThi, id_dot_thi);
        if (res.is_success) {
            yield put(rootActions.toChucThi.dsDoiTuongDuThi.LOAD_SUCCESS(res.data));
        } else {
            yield put(rootActions.toChucThi.dsDoiTuongDuThi.LOAD_ERROR(res.message ?? "Có lỗi"));
        } 
}

function* updateDuyetWorker(action: IDsDoiTuongDuThiActionTypes): any {
    const request = action.payload as IDsDoiTuongDuThiUpdateDuyetRequest;
    const res: IBaseRespone = yield call(dsDoiTuongDuThiApi.UpdateDuyet, request);
    if (res.is_success) {
        yield put(rootActions.toChucThi.dsDoiTuongDuThi.UPDATE_DUYET_SUCCESS(undefined));
    } else {
        yield put(rootActions.toChucThi.dsDoiTuongDuThi.UPDATE_DUYET_ERROR(res.message ?? "Có lỗi"));
    }
}